import styled, { css } from "styled-components";

import { colorsPalettes, elevation, rgba } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const MANAGEMENT_CARD_BORDER_RADIUS = 6;

const cardSurface = css`
    padding: 24px;
    position: relative;
    border-radius: ${MANAGEMENT_CARD_BORDER_RADIUS}px;
    background: ${colorsPalettes.carbon["0"]};

    box-shadow: ${elevation.Z1};
`;

export const StyledManagementCardSurface = styled(Flex)`
    width: 100%;
    flex-direction: column;
    ${cardSurface}
`;

export const StyledManagementCardWrapper = styled(Flex)`
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
    ${cardSurface}
`;

/**
 * Grid card surface used inside a `CardsWrapper` grid. Spans 3 parent rows and
 * subgrids them so that header / body / footer of every card in a row share the
 * same row tracks (and therefore align across cards). Outside of a grid parent
 * it gracefully degrades to a standalone 3-row grid.
 *
 * Gaps: parent grid keeps the 24px row-gap (between card rows and body→footer),
 * the subgrid overrides its own row-gap to 8px (header→body) and the footer slot
 * adds the remaining 16px so body→footer stays 24px.
 */
export const StyledManagementCardGridWrapper = styled.div`
    display: grid;
    grid-row: span 3;
    grid-template-rows: subgrid;
    row-gap: 8px;
    ${cardSurface}
`;

export const StyledManagementCardHeaderSlot = styled.div`
    grid-row: 1;
    align-self: center;
`;

export const StyledManagementCardBodySlot = styled.div`
    grid-row: 2;
    align-self: start;
`;

export const StyledManagementCardFooterSlot = styled.div`
    grid-row: 3;
    align-self: start;
    margin-top: 16px;
`;

export const StyledManagementCardIconButton = styled(IconButton)`
    justify-content: center;

    & > div {
        flex-grow: unset;
    }
`;

export const StyledManagementCardButton = styled(Button)`
    width: 100%;
`;

export const StyledManagementCardFooterWrapper = styled(Stack)`
    gap: 24px;
`;

export const StyledManagementCardTagWrapper = styled(Flex)`
    flex-wrap: wrap;
    gap: 8px;
`;

export const StyledManagementCardTag = styled(Flex)`
    gap: 4px;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 8px 12px;
    border-radius: 16px;
    background: ${rgba(colorsPalettes.carbon[200], 0.2)};
`;

export const StyledManagementCardContentList = styled(Flex)`
    width: 100%;
    gap: 8px;
    justify-content: space-between;
`;

export const StyledManagementCardIconsWrapper = styled(Flex)`
    width: 64px;
    height: 64px;
    padding: 8px;
    justify-content: center;
    align-items: center;

    border-radius: 6px;
    border: 1px solid ${colorsPalettes.carbon["50"]};
    background: ${colorsPalettes.carbon["0"]};
`;
